import { Injectable } from '@angular/core';
import { AuthenticationService } from './authenticationService';
import { Config, dynamicDataTranslationURL, multiLanguageServerURL } from '../_store';

import * as moment from 'moment';
import { environment } from '../../environments/environment';
import { CommonDataService } from '../appDataServices/commonDataService';
import { CommonService } from './common.service';
import { DateUtilsService } from './dateUtils';
import { DYNAMIC_DATA_LABELS, EN_JSON } from '../_store/offlineData';
import { StorageService } from './storage.service';
import { RejectionApprovedlistItemComponent } from '../salesapprovalpage/common/rejection-approvedlist-item/rejection-approvedlist-item.component';
import { HttpClient } from '@angular/common/http';
import { StringConstants } from '../_constants/stringConstants';
import * as CryptoJS from 'crypto-js';

@Injectable({ providedIn: 'root' })
export class OfflineService {
    offlineData: any;
    imgUrl = 'assets/offline/0.png';
    allowedSellers = ['sbd', 'continental'];
    enLangJSONUrl = 'https://qa.payex.live/PayEXDCAPI/static/lang-assets/i18n/en.json'
    dataConstants = {
        CPG_ID: 'CPGXYZ',
        CPG_DN: 'ABC Insurance'
    };
    buyerOptionConfig = {
        'sbd': { reqToRecon: true, companyAccntStmt: true, canAssignSD: true, downloadStmt: true, payAdvance: true },
        'continental': { reqToRecon: true, companyAccntStmt: false, canAssignSD: true, downloadStmt: true, payAdvance: true },
        'valvoline': { reqToRecon: true, companyAccntStmt: true, canAssignSD: true, downloadStmt: true, payAdvance: true },
        'transworld': { reqToRecon: true, companyAccntStmt: false, canAssignSD: false, downloadStmt: true, payAdvance: true },
        'kone': { reqToRecon: true, companyAccntStmt: true, canAssignSD: false, downloadStmt: false, payAdvance: true },
    }

    
    sellerAVariables ={
        buyerCode : "00BYRDMOSA",
        userName :  "BuyerSellerA",
        sellerCode : "SellerA"
    }
    sellerBVariables = {
        buyerCode : "00BYRDMOSB",
        userName :  "BuyerSellerB",
        sellerCode : "SellerB"
    }
    cashDiscountRate = 2.5;
    currencyCode = Config.defaultCurr;


    constructor(
        private commonService : CommonService,
        private dateUtils : DateUtilsService,
        private storageService : StorageService,
        private http : HttpClient
    ) {
        this.clearOfflineData();
    }

    clearOfflineData() {
        this.offlineData = {
            paidInvoices: {},
            deferredInvoices: {},
            usedCRNMap: {},
            invoiceResponse: {
                data: {
                    transactions: { transactions: [] },
                    invoices: []
                }
            },
            pendingCRN: [],
            usedCRN: [],
            paymentSchedule: {
              paymentSchedule: []
            }
        };
    }

    initOfflineDocuments() {

        this.storageService.get(StringConstants.CURRENT_CURRENCY).then(lang => {
            if (lang !== null && lang !== undefined && lang !== '') {
                this.currencyCode = lang;
            } else {
                // Default to app-wide configured currency
                this.currencyCode = Config.defaultCurr;
            }
        const invoicesResponse = this.generateGetInvoiceResponse();
        const transactionResponse = this.generateGetTransactionResponse();
        const creditNoteResponse = this.generateGetCreditNoteResponse()

        this.storageService.addLocalStorage(Config.webActions.GETINVOICES,JSON.stringify(invoicesResponse))
        this.storageService.addLocalStorage(Config.webActions.GETTRANSACTIONS,JSON.stringify(transactionResponse))
        this.storageService.addLocalStorage(Config.webActions.CREDIT_NOTES_LIST,JSON.stringify(creditNoteResponse))

          })

    }

    clearOfflineDocuments() {
        this.storageService.removeLocalStorage(Config.webActions.GETINVOICES);
        this.storageService.removeLocalStorage(Config.webActions.GETTRANSACTIONS);
        this.storageService.removeLocalStorage(Config.webActions.CREDIT_NOTES_LIST);


    }

    reInitializeOfflineDocuments() {
        this.clearOfflineDocuments();
        this.initOfflineDocuments();
    }

    async getDummyResponse(url,request: any ={}) {
        let data;
        console.log("url : ", url);
        
        //const switchParam = request && request.action ? request.action : url;
        switch (url) {
            case multiLanguageServerURL:
                data = this.getLangConfig();
                break;
            case dynamicDataTranslationURL:
                data = this.getDynamicData();
                break; 
            case this.enLangJSONUrl :
                data = this.getLanguageEN()
            case Config.webActions.LOGIN:
                data = this.getLoginResponse();
                break;
            case Config.webActions.GETOPT:
                data = this.getOTPResponse();
                break;
            case Config.webActions.GETTOKEN:
                data = this.getOTPAuthResponse();
                break;
            case Config.webActions.GETRETAILER:
                break;
            case Config.webActions.DISTRIBUTORS:
                data = this.getDistributors();
                break;
            case Config.webActions.CHECK_AUTO_SCHEDULE:
                data = this.getAutoPullResponse();
                break;
            case Config.webActions.SCHEDULED_INVOICES:
                data = this.getScheduledInvoicesResponse();
                break;
            case Config.webActions.DEFERMENT_REQUEST:
                data = this.deferInvoice(request);
                break;
            case Config.webActions.GETSELLERS:
                data = this.getSellers();
                break;
            case Config.webActions.GETINVOICES:
                data = await this.getInvoiceResponse();
                this.storageService.addLocalStorage(Config.webActions.GETINVOICES,JSON.stringify(data))
                break;
            case Config.webActions.INVOICE_CD:
                data = this.getCDFactorResponse();
                break;
            case Config.webActions.INVOICE_CD_M:
                data = this.getInvoiceResponse();
                break;
            case Config.webActions.CRNTLIST:
                data = this.getCreditNotesForInvoice(request);
                break;
            case Config.webActions.GETTRANSACTIONS:
                data = this.getTransactionResponse();
                break;
            case Config.webActions.GETTRANSACTIONSDETAILS:
                data = await this.getTransactionDetails(request);
                break;   
            case Config.webActions.TRANSDETAIL:
                data = this.getOTPAuthResponse();
                break;
            case Config.webActions.NEFT_BAL:
                data = this.getInvoiceResponse();
                break;
            case Config.webActions.NEFT_CRED_BAL:
                data = this.getNEFTCREDBalanceResponse();
                break;
            case Config.webActions.INVOICE_CD_M:
                data = this.getInvoiceResponse();
                break;
            case Config.webActions.MULTIPAY_SETTINGS:
                data = {};
                break;
            case Config.webActions.GET_BUYER_OPTIONS:
                const sellerCodes = (request.sellerCodes) || [];
                let reqToRecon = false, companyAccntStmt = false, canAssignSD = false, payAdvance = true, downloadStmt = true;
                sellerCodes.forEach(sellerCode => {
                    const sellerConfig = this.buyerOptionConfig[sellerCode.toLowerCase()] || {};
                    reqToRecon = reqToRecon || sellerConfig.reqToRecon;
                    companyAccntStmt = companyAccntStmt || sellerConfig.companyAccntStmt;
                    canAssignSD = canAssignSD || sellerConfig.canAssignSD;
                    downloadStmt = downloadStmt && (typeof sellerConfig.downloadStmt === 'undefined' ? true : sellerConfig.downloadStmt);
                    payAdvance = payAdvance && (typeof sellerConfig.payAdvance === 'undefined' ? true : sellerConfig.payAdvance);
                })
                data = this.getBuyerOptions({ reqToRecon, companyAccntStmt, canAssignSD, downloadStmt, payAdvance });
                // console.log(data)
                break;
            case Config.webActions.V_ACC:
                data = { "msg": "", "data": "SBD001234567890#ICIC0SF1234", "error": "", "status": true };
                break;
            case Config.webActions.VIRTUAL_DETAILS:
                data = {
                    "data": {
                        "accntNo": "55323434282",
                        "ifscCode": "SCBL0327125",
                        "beneficiaryName": null,
                        "bankName": "SCB",
                        "banks": [
                            {
                                "bankNm": "Andhra Bank",
                                "bankUrl": "https://www.unionbankofindia.co.in/english/internet-banking.aspx"
                            },
                            {
                                "bankNm": "Bank of Maharashtra",
                                "bankUrl": "https://bankofmaharashtra.in/internet-banking"
                            },
                            {
                                "bankNm": "Indian Overseas Bank",
                                "bankUrl": "https://www.iobnet.co.in/ibanking/html/index.html"
                            },
                            {
                                "bankNm": "Bank of Baroda",
                                "bankUrl": "https://www.bankofbaroda.in/personal-banking/digital-products/instant-banking/bob-world-internet-banking"
                            },
                            {
                                "bankNm": "City Union Bank (CUB)",
                                "bankUrl": "https://www.cityunionbank.com/"
                            },
                            {
                                "bankNm": "SBI Bank",
                                "bankUrl": "https://corp.onlinesbi.com/corpuser/login.htm"
                            },
                            {
                                "bankNm": "Yes Bank",
                                "bankUrl": "https://yesonline.yesbank.co.in/index.html?module=login"
                            },
                            {
                                "bankNm": "Citi Bank",
                                "bankUrl": "https://www.online.citibank.co.in/personal-banking/internet-banking"
                            },
                            {
                                "bankNm": "KOTAK",
                                "bankUrl": "https://www.kotak.com/j1001mp/netapp/MainPage.jsp"
                            },
                            {
                                "bankNm": "J&K bank",
                                "bankUrl": "https://www.jkbankonline.com"
                            },
                            {
                                "bankNm": "Axis Bank Personal Banking",
                                "bankUrl": "https://retail.axisbank.co.in/wps/portal/rBanking/axisebanking/AxisRetailLogin/!ut/p/a1/04_Sj9CPykssy0xPLMnMz0vMAfGjzOKNAzxMjIwNjLwsQp0MDBw9PUOd3HwdDQwMjIEKIoEKDHAARwNC-sP1o_ArMYIqwGNFQW6EQaajoiIAVNL82A!!/dl5/d5/L2dBISEvZ0FBIS9nQSEh/"
                            },
                            {
                                "bankNm": "Allahabad Bank",
                                "bankUrl": "https://www.netbanking.indianbank.in/jsp/startIBPreview.jsp"
                            },
                            {
                                "bankNm": "Punjab & Sind Bank",
                                "bankUrl": "https://punjabandsindbank.co.in/"
                            },
                            {
                                "bankNm": "Syndicate Bank",
                                "bankUrl": "https://online.canarabank.in/?module=login"
                            },
                            {
                                "bankNm": "IDBI Bank Ltd.",
                                "bankUrl": "https://www.idbibank.in/index.asp"
                            },
                            {
                                "bankNm": "Varachha Co-operative Bank",
                                "bankUrl": "https://netbanking.varachhabank.com/inet/login"
                            },
                            {
                                "bankNm": "The Federal Bank Ltd",
                                "bankUrl": "https://www.fednetbank.com"
                            },
                            {
                                "bankNm": "City Union Bank",
                                "bankUrl": "https://www.cityunionbank.com/"
                            },
                            {
                                "bankNm": "DCB Bank",
                                "bankUrl": "https://www.dcbbank.com/"
                            },
                            {
                                "bankNm": "Saraswat Bank",
                                "bankUrl": "https://findigital.saraswatbank.com/corp/AuthenticationController?__START_TRAN_FLAG__=Y&FORMSGROUP_ID__=AuthenticationFG&__EVENT_ID__=LOAD&FG_BUTTONS__=LOAD&ACTION.LOAD=Y&AuthenticationFG.LOGIN_FLAG=1&BANK_ID=01&LANGUAGE_ID=001"
                            },
                            {
                                "bankNm": "Telangana Grameena Bank",
                                "bankUrl": "https://tgbhyd.in/#/"
                            },
                            {
                                "bankNm": "Capital Small Finance Bank",
                                "bankUrl": "https://netbanking.capitalbank.in/ReachIB/inetbanking/webindex"
                            },
                            {
                                "bankNm": "RBL Bank",
                                "bankUrl": "https://online.rblbank.com/CorpBank/AuthenticationController?FORMSGROUP_ID__=AuthenticationFG&__START_TRAN_FLAG__=Y&__FG_BUTTONS__=LOAD&ACTION.LOAD=Y&AuthenticationFG.LOGIN_FLAG=1&BANK_ID=176"
                            },
                            {
                                "bankNm": "HDFC",
                                "bankUrl": "https://www.hdfcbank.com"
                            },
                            {
                                "bankNm": "Karnataka bank",
                                "bankUrl": "https://karnatakabank.com/digital-banking/internet-banking-services"
                            },
                            {
                                "bankNm": "Axis Bank Corporate Banking",
                                "bankUrl": "https://idp.axisbank.co.in/mib/Welcome?_ga=2.209617618.1348934503.1657085907-530777708.1657085907#!"
                            },
                            {
                                "bankNm": "Bank of India",
                                "bankUrl": "https://www.bankofindia.co.in/"
                            },
                            {
                                "bankNm": "Canara Bank",
                                "bankUrl": "https://online.canarabank.in/?module=login"
                            },
                            {
                                "bankNm": "Central Bank of India",
                                "bankUrl": "https://www.centralbankofindia.co.in/en"
                            },
                            {
                                "bankNm": "Corporation Bank",
                                "bankUrl": "https://www.unionbankofindia.co.in/english/internet-banking.aspx"
                            },
                            {
                                "bankNm": "Dena Bank",
                                "bankUrl": "https://www.bankofbaroda.in/personal-banking/digital-products/instant-banking/bob-world-internet-banking"
                            },
                            {
                                "bankNm": "United Bank of India",
                                "bankUrl": "https://netpnb.com/"
                            },
                            {
                                "bankNm": "SCB",
                                "bankUrl": "https://www.sc.com/in/"
                            },
                            {
                                "bankNm": "The South Indian Bank",
                                "bankUrl": "https://sibernet.southindianbank.com/corp/AuthenticationController?FORMSGROUP_ID__=AuthenticationFG&__START_TRAN_FLAG__=Y&FG_BUTTONS__=LOAD&ACTION.LOAD=Y&AuthenticationFG.LOGIN_FLAG=1&BANK_ID=059"
                            },
                            {
                                "bankNm": "Karur Vysya Bank",
                                "bankUrl": "https://www.kvbin.com/B001/ENULogin.jsp"
                            },
                            {
                                "bankNm": "Bandhan Bank",
                                "bankUrl": "https://bandhanbankonline.com/netbanking/#/"
                            },
                            {
                                "bankNm": "AU SMALL FINANCE BANK",
                                "bankUrl": "https://www.aubank.in/"
                            },
                            {
                                "bankNm": "IndusInd Bank",
                                "bankUrl": "https://indusnet.indusind.com/corp/BANKAWAY?Action.RetUser.Init.001=Y&AppSignonBankId=234&AppType=corporate&CorporateSignonLangId=001"
                            },
                            {
                                "bankNm": "The Mehsana Urban Co Op Bank Ltd",
                                "bankUrl": "https://www.mucbank.com/mucb/"
                            },
                            {
                                "bankNm": "Indian Bank",
                                "bankUrl": "https://www.indianbank.in/"
                            },
                            {
                                "bankNm": "Oriental Bank of Commerce",
                                "bankUrl": "https://netpnb.com/"
                            },
                            {
                                "bankNm": "UCO Bank",
                                "bankUrl": "https://www.ucobank.com/english/home.aspx"
                            },
                            {
                                "bankNm": "Vijaya Bank",
                                "bankUrl": "https://www.bankofbaroda.in/personal-banking/digital-products/instant-banking/bob-world-internet-banking"
                            },
                            {
                                "bankNm": "Surat National Co-operative Bank",
                                "bankUrl": "https://www.suratnationalbank.com"
                            },
                            {
                                "bankNm": "Catholic Syrian Bank",
                                "bankUrl": "https://www.csb.co.in/net-banking"
                            },
                            {
                                "bankNm": "Deutsche Bank",
                                "bankUrl": "https://www.deutschebank.co.in/login.html"
                            },
                            {
                                "bankNm": "Punjab National Bank",
                                "bankUrl": "https://netpnb.com/"
                            },
                            {
                                "bankNm": "Union Bank",
                                "bankUrl": "https://www.unionbankonline.co.in/"
                            },
                            {
                                "bankNm": "TamilNad Mercantile Bank (TMB)",
                                "bankUrl": "https://www.tmbnet.in/"
                            },
                            {
                                "bankNm": "IDFC First Bank",
                                "bankUrl": "https://my.idfcbank.com/start"
                            },
                            {
                                "bankNm": "ICICI",
                                "bankUrl": "https://www.icicibank.com/Personal-Banking/insta-banking/internet-banking/index.page"
                            }
                        ]
                    },
                    "success": true,
                    "msg": "",
                    "msgCode": "DEFAULT_BLANK"
                };
                break;
            
            case Config.webActions.PROCESS_MANUAL_KNOCKOFF :
                data = {
                    "success": true,
                    "msg": "Transaction completed successfully",
                    "msgCode": "MANUAL_KNOCKOFF_MSG",
                    "status": "success"
                }
                break;
                
            case Config.webActions.PAYMENT:
                data = this.payInvoice(request);
                break;
            case Config.webActions.ADVPAY:
                data = this.advancePay(request);
                break;
            case Config.webActions.GETRIBBON:
                data = this.ribbonData(request);
                break;
            case Config.webActions.PAYMENT_OPTIONS:
                data = this.getBankOptions();
                break;  
            case Config.webActions.PAYSETTINGS:
                data = this.getPaySettings();
                break;
            case Config.webActions.PAY_REASONS:
                data = this.getPayReasons();
                break;

            case Config.webActions.RTR_LINK: 
                data = {
                    "status": "success",
                    "message": "successfully loaded",
                    "data": [
                        {
                            "VAccNo": "TW0020226304",
                            "utr": "221201114417",
                            "amt": 5000,
                            "reqActivateTime": 1743486978584,
                            "url": "https://qa.payex.live/#/landing/eyJidXllckNvZGUiOiIwMDIwMjI2MzA0IiwiVkFjY05vIjoiVFcwMDIwMjI2MzA0Iiwic2VsbGVyQ29kZSI6IlRyYW5zd29ybGQiLCJ1dHIiOiIyMjEyMDExMTQ0MTciLCJhbXQiOjUwMDAuMDAsInJlcUFjdGl2YXRlVGltZSI6MTc0MzQ4Njk3ODU4NCwiY3V0T2ZmRGF0ZSI6MTc0MzUxMTgwMDAwMCwibW9kZSI6Imtub2NrLW9mZiJ9"
                        },
                        {
                            "VAccNo": "TW0020226304",
                            "utr": "221201114418",
                            "amt": 500,
                            "reqActivateTime": 1743486997541,
                            "url": "https://qa.payex.live/#/landing/eyJidXllckNvZGUiOiIwMDIwMjI2MzA0IiwiVkFjY05vIjoiVFcwMDIwMjI2MzA0Iiwic2VsbGVyQ29kZSI6IlRyYW5zd29ybGQiLCJ1dHIiOiIyMjEyMDExMTQ0MTgiLCJhbXQiOjUwMC4wMCwicmVxQWN0aXZhdGVUaW1lIjoxNzQzNDg2OTk3NTQxLCJjdXRPZmZEYXRlIjoxNzQzNTExODAwMDAwLCJtb2RlIjoia25vY2stb2ZmIn0"
                        }
                    ]
                }
                break;


            case Config.webActions.GET_INVOICES_FOR_MANUAL_KNOCKOFF:
                console.log(request);

                // Retrieve full invoice list from local storage (same as GETINVOICES)
                var invoiceReq: any = JSON.parse(this.storageService.getLocalStorage(Config.webActions.GETINVOICES));
                const allInvoices = (invoiceReq && invoiceReq.data && invoiceReq.data.invoices) || {};
                const allOrder = (invoiceReq && invoiceReq.data && (invoiceReq.data.order || invoiceReq.data.invoiceOrder)) || [];

                const sellerCode = request.sellerCode;
                const buyerCode = request.buyerCode;

                const filteredInvoices: any = {};
                const filteredOrder: string[] = [];
                let totalAmount = 0;

                allOrder.forEach((invKey: string) => {
                    const inv = allInvoices[invKey];
                    if (!inv) { return; }
                    if (sellerCode && inv.sellerCode !== sellerCode) { return; }
                    if (buyerCode && inv.buyerCode !== buyerCode) { return; }

                    filteredInvoices[invKey] = inv;
                    filteredOrder.push(invKey);
                    totalAmount += inv.dueAmt || inv.docAmt || 0;
                });

                const sellerConfig = (invoiceReq.data && invoiceReq.data.sellerConfig) || {};

                data = {
                    data: {
                        invoices: filteredInvoices,
                        invoiceOrder: filteredOrder,
                        sellerConfig: sellerConfig,
                        groupConfig: invoiceReq.data.groupConfig || {},
                        paymentDetails: {
                            amount: totalAmount,
                            utrNo: request.utrNo || request.utrNoRef || ''
                        },
                        serverTime: invoiceReq.data.serverTime || Date.now()
                    },
                    success: true,
                    msg: '',
                    msgCode: 'DEFAULT_BLANK'
                };
                break;
            case Config.webActions.CREDIT_NOTES_LIST:
                
                data = this.getCreditNotesForList();
                break;    
            case Config.webActions.CREDIT_NOTES_PAYMENT:
                console.log("cn call");
                
                data = this.getCreditNotesForPaymnet();
                break;
            case Config.webActions.GET_ELLIGIBLE_CASH_DISCOUNT:
                data = this.getCashDiscount(request);
                break;
            case Config.webActions.GET_CASHDISCOUNT_FOR_INVOICES_LIST:
                data = this.getCashDiscountList(request);
                break;
            case Config.webActions.ADVPAYSETTINGS:
                data = this.advancePaySettings(request);
                break;    
            case Config.webActions.VIEW_OUTSTANDING_STMT:
                data = await this.viewStatement();
                console.log(data);
                break; 
            case Config.webActions.GET_CURRENCIES:
                data = await this.getCurrencies(request);
                console.log(data);
                break; 
            case Config.webActions.SET_PAYMENT_SCHEDULE:
                data = await this.setPaymentSchedule(request);
                console.log(data);
                break;
                case Config.webActions.LIST_AUTOPAY:
                    data = await this.getPaymentSchedule();
                    console.log(data);
                    break;
            case Config.webActions.DELETE_PAYMENT_SCHEDULE:
                data = await this.deletePaymentSchedule(request);
                console.log(data);
                break;

            default:
                console.log("url : ", url);
                console.log("request : ", request);

                data = {};
        }
        console.log(data);
        
        return data
    }

    getDummyResponseNodeURL(url,request: any ={}){
        console.log("in node bummy");
        
        console.log(url);
        console.log(Config.dashboardServiceEndpoints.LOGIN);
        
        switch (url) {
            case Config.dashboardServiceEndpoints.LOGIN:
                return {
                    "code": 200,
                    "data": {
                        "session": {
                            "sessionId": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.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.a9p7ovrIQeFwNA00IEmlomxAqM1-jiLfjLuiFuE8A10"
                        },
                        "user": {
                            "displayName": "Buyer Demo",
                            "userRoles": "Buyer",
                            "sellerCode": "SellerA",
                            "eippSession": {
                                "sessionId": "298fc7ec-79c4-4091-8a20-1d75e7af1e5c_41454015351580565",
                                "username": "1003202303",
                                "sessionTimeout": 240,
                                "expiryDate": 1738669220477
                            },
                            "userActions": {},
                            "otherData": {},
                            "billConfig": {},
                            "uiConfig": {
                                "statusDescriptions": {
                                    "APPROVAL_PENDING": "Approval Pending",
                                    "PARTIALLY_PAID": "Partially Paid",
                                    "REJECTION_APPROVAL_PENDING": "Rejection approval pending",
                                    "REJECTED": "Rejected",
                                    "APPROVED": "Approved",
                                    "FULLY_PAID": "Fully Paid",
                                    "USED": "Used",
                                    "UNUSED": "Pending",
                                    "UNPAID": "Pending",
                                    "PARTIALLY_USED": "Partially Used",
                                    "SUCCESS": "Paid",
                                    "FAILED": "Failed"
                                },
                                "userAllowedActions": [
                                    "requestRTP"
                                ],
                                "statusToAlwaysDisplayForFilter": {
                                    "INV_DN": [
                                        "APPROVAL_PENDING",
                                        "PARTIALLY_PAID",
                                        "REJECTED",
                                        "FULLY_PAID",
                                        "UNPAID",
                                        "FAILED",
                                        "REJECTION_APPROVAL_PENDING",
                                        "IN_BANK_PROC"
                                    ],
                                    "CN": []
                                },
                                "documentSummary": {
                                    "DOC_PAID_TODAY": "Document(s) paid today",
                                    "DOC_APPROVED_TODAY": "Document(s) approved today",
                                    "DOC_PAID_THIS_MONTH": "Document(s) paid this month",
                                    "TOTAL_CUSTOMERS_ACTIVE_ON_FREEPAY": "Total customers active on Freepay",
                                    "TOTAL_PENDING_DOC_ON_FREEPAY": "Total pending Document(s) on Freepay",
                                    "TOTAL_PAID_DOC_ON_FREEPAY": "Total paid Document(s) on Freepay",
                                    "TOTAL_OVERDUE_DOC_ON_FREEPAY": "Total overdue Document(s) on Freepay"
                                },
                                "tableConfig": {
                                    "algPaymentAdvices": {
                                        "cols": [
                                            {
                                                "name": "Payment Advice",
                                                "dataCol": "payadviceName",
                                                "columnname": "payadviceName",
                                                "sortable": false,
                                                "isTemplateCol": true
                                            },
                                            {
                                                "name": "Buyer Code",
                                                "dataCol": "buyerCode",
                                                "columnname": "buyerCode",
                                                "sortable": true
                                            },
                                            {
                                                "name": "Buyer Name",
                                                "dataCol": "buyerName",
                                                "columnname": "buyerName",
                                                "sortable": false
                                            },
                                            {
                                                "name": "Invoice Number",
                                                "dataCol": "docNo",
                                                "columnname": "docNo",
                                                "sortable": true
                                            },
                                            {
                                                "name": "Bank UTR",
                                                "dataCol": "bankUtr",
                                                "columnname": "bankUtr",
                                                "sortable": true
                                            },
                                            {
                                                "name": "Invoice Date",
                                                "dataCol": "docDateFormatted",
                                                "columnname": "docDate",
                                                "sortable": true
                                            },
                                            {
                                                "name": "Invoice Amount",
                                                "dataCol": "docAmountFormatted",
                                                "columnname": "docAmount",
                                                "isAmount": true,
                                                "sortable": true
                                            },
                                            {
                                                "name": "Payment Advice Amount",
                                                "dataCol": "payAdvanceAmtFormatted",
                                                "columnname": "payAdviceAmt",
                                                "isAmount": true,
                                                "sortable": true
                                            },
                                            {
                                                "name": "Difference",
                                                "dataCol": "diffAmtFormatted",
                                                "columnname": "difference",
                                                "isAmount": true,
                                                "sortable": true
                                            },
                                            {
                                                "name": "Due Date",
                                                "dataCol": "dueDateFormatted",
                                                "columnname": "dueDate",
                                                "sortable": true
                                            },
                                            {
                                                "name": "Payment Recv Date",
                                                "dataCol": "paymentRecvDateFormatted",
                                                "columnname": "payDate",
                                                "sortable": true
                                            },
                                            {
                                                "name": "Ageing Status",
                                                "dataCol": "paidStatus"
                                            },
                                            {
                                                "name": "Recon Status",
                                                "dataCol": "reconStatusDesc",
                                                "class": "statusClass",
                                                "sortable": false,
                                                "columnname": "reconStatus"
                                            },
                                            {
                                                "name": "Narration",
                                                "dataCol": "narration",
                                                "isTemplateCol": true
                                            },
                                            {
                                                "name": "Adjustments",
                                                "dataCol": "adjustments",
                                                "isTemplateCol": true
                                            },
                                            {
                                                "name": "Suggested Actions",
                                                "dataCol": "suggestedActions",
                                                "isTemplateCol": true,
                                                "showWhenSuggestedActionAllowed": true,
                                                "notAllowedRole": [
                                                    "SellerViewOnly"
                                                ]
                                            }
                                        ]
                                    }
                                }
                            },
                            "sellerConfig": {
                                "ledgerMetaData": {
                                    "endPoints": {
                                        "auth": {
                                            "apiKey": "VHJhbnN3b3JsZDpwYXlleDMyMQ==",
                                            "apiEndpoint": "ledger"
                                        },
                                        "inFldr": "/home/payexfiles/seller/SellerA/Outbound/Current",
                                        "errFldr": "",
                                        "processedFldr": ""
                                    }
                                },
                                "buyerMetaData": {
                                    "endPoints": {
                                        "auth": {
                                            "apiKey": "",
                                            "apiEndpoint": "buyer"
                                        },
                                        "inFldr": "/home/payexfiles/buyer/SellerA/Outbound/Current",
                                        "errFldr": "",
                                        "processedFldr": ""
                                    }
                                }
                            },
                            "userDescendants": {
                                "buyers": [],
                                "users": []
                            },
                            "eippSessionData": {
                                "data": {
                                    "session": {
                                        "sessionId": "298fc7ec-79c4-4091-8a20-1d75e7af1e5c_41454015351580565",
                                        "username": "1003202303",
                                        "sessionTimeout": 240,
                                        "expiryDate": 1738669220477
                                    },
                                    "user": {
                                        "displayName": "Buyer Demo",
                                        "mobile": 1003202303,
                                        "email": "gifty.akonnor+1003202303@globalpayex.com",
                                        "userChangeReq": false,
                                        "forcePinChange": false,
                                        "userRole": "Buyer",
                                        "forceTCAgreement": false,
                                        "sellerCode": "SellerA",
                                        "enableRTR": true
                                    }
                                },
                                "success": true,
                                "msg": "Login Successfully",
                                "msgCode": "LOGIN_SUCCESSFULLY"
                            }
                        }
                    },
                    "message": "SUCCESS",
                    "success": true
                }
                break ;
        }

    }


    getCashDiscountList(payload : any = {}): any {
        const CD = this.cashDiscountRate;
        var invoicesResponse = JSON.parse(this.storageService.getLocalStorage(Config.webActions.GETINVOICES))
        const currentDate = this.dateUtils.getToday();
        // const today = this.dateUtils.formatDate(
        //     this.dateUtils.addDaysToDate(currentDate, 2), 'YYYY-MM-DD'
        // );
        // console.log(today);
        
        let invoices = []
        payload.docId.forEach(invoice => {            
            if(invoicesResponse.data.invoices[invoice] && this.dateUtils.getDateDiff(currentDate,invoicesResponse.data.invoices[invoice].dueDate)<=0){
                const amount = invoicesResponse.data.invoices[invoice].dueAmt*(CD/100)
                invoices.push({
                    "docId": invoice,
                    "text": `Pay by ${currentDate} and get discount of ${CD}% ${invoicesResponse.data.invoices[invoice].currCode} ${amount}`
                },)
            }
        });


        // {
        //     "status": "success",
        //     "message": "discount fetched successfully",
        //     "data": {
        //         "currCode": this.currencyCode,
        //         "invoice": [
        //             {
        //                 "docId": "0000232303~9505201023~INV~2023",
        //                 "text": "Pay by 2025-02-15 and get discount of 2.5% INR 13.88"
        //             }
        //         ]
        //     }
        // }

        
        const data ={
            "status": "success",
            "message": "discount fetched successfully",
            "data": {
                "currCode": this.currencyCode,
                "invoice": invoices,
            }
        }
        return data;
    }

    getCashDiscount(payload) {
        console.log("payload for get cash discount");
        
        console.log(payload);

        var totalCashDiscount = 0
        const discountInvoices = [];
        const today =   this.dateUtils.getToday()
        var transactionReq: any = JSON.parse(this.storageService.getLocalStorage(Config.webActions.GETTRANSACTIONS));
        var invoiceReq: any = JSON.parse(this.storageService.getLocalStorage(Config.webActions.GETINVOICES));
        var transactions: any = transactionReq.data.transactions;
        var orderTransaction : any[] = transactionReq.data.order
        var invoices: any = invoiceReq.data.invoices;
        var orderInvoices = invoiceReq.data.order;
        
        let cashDiscount = 0;
        payload.docId.forEach(docId => {
            if (invoices.hasOwnProperty(docId)) {
                
                const invoice = invoices[docId];
                if(invoice && this.dateUtils.getDateDiff(today,invoice.dueDate)<=0){

                    const dueAmt = Number(invoice.dueAmt) || 0;
                    const discountAmt = parseFloat((dueAmt * (this.cashDiscountRate / 100)).toFixed(2));
                    const dueAmtAfterDiscount = parseFloat((dueAmt - discountAmt).toFixed(2));
    
                    totalCashDiscount += discountAmt;
    
                    discountInvoices.push({
                    docId: docId,
                    discountRate: this.cashDiscountRate,
                    //   discountEndDate: invoice.discountEndDate, // assuming invoice has this field
                    dueAmt: dueAmt,
                    discountAmt: discountAmt,
                    dueAmtAfterDiscount: dueAmtAfterDiscount,
                    //   payableAmt: invoice.payableAmt // assuming invoice has this field
                    });
                }
            }
        });
        const aa ={
            "status": "success",
            "message": "discount fetched successfully",
            "data": {
                "currCode": this.currencyCode,
                "invoice": discountInvoices,
                "totalCashDiscount" : totalCashDiscount
            }
        }
        return aa;
    }

    private getLangConfig() {
        return [
            {
                "ShortCode": "en",
                "FullName": "English",
                "icon": "https://rearchqa.payex.live/PayEXDCAPI/static/lang-assets/icons/united-states.png"
            },
        ]
    }

    private getDynamicData() {
        return DYNAMIC_DATA_LABELS
    }

    private getLanguageEN() {
        console.log("enjson");
        
        return EN_JSON
    }
    private getLoginResponse() {
        console.log("in login");
        
        return {
            "data": {
                "session": {
                    "sessionId": "27818340-8c42-43b2-b361-8b045b0b886e_18397221265368480",
                    "username": "2202240702",
                    "sessionTimeout": 5,
                    "expiryDate": 1715598326384
                },
                "user": {
                    "displayName": "BuyerDemo",
                    "mobile": 2202240702,
                    "email": "abc.pqr@globalpayex.com",
                    "userChangeReq": false,
                    "forcePinChange": false,
                    "userRole": "Buyer",
                    "forceTCAgreement": false,
                    "sellerCode": "SellerA",
                    "enableRTR": true
                }
            },
            "success": true,
            "msg": "Login Successfully",
            "msgCode": "LOGIN_SUCCESSFULLY"
        }
    }

    private getOTPResponse() {
        return { "status": true, "msg": "A SMS with OTP is sent to your registered Email / Mobile No. Enter OTP to activate your mobile.", "error": "", "data": { "otp": "1111", "user": { "retailerName": "FREEPAY MATERIALS", "payexRetailerCode": "PAY1234567890", "retailerBanks": "", "allowedClient": "IWA", "active_flag": 0, "update_count": 0, "gcmRegistrationId": "", "operator": "retailer", "validRetailer": true, "userType": 0 } } };
    }

    private getOTPAuthResponse() {
        return { "status": true, "msg": "Your registration is now verified.", "error": "", "data": { "msg": "Dear Freepay user, your temporary transaction PIN is 1234. We recommend you to change the PIN and not disclose it to anyone.", "token": { "expiresIn": 13110, "scope": "read write trust", "refreshTimestamp": "Dec 3, 2019 6:38:46 PM", "accessToken": "5be0ebf5-e97b-428a-90d5-9703883fe4a1", "tokenType": "bearer", "accessTimestamp": "Dec 3, 2019 6:38:46 PM", "refreshToken": "90ef1a9c-71b6-4cdd-a3a0-3917e26956da" } } };
    }

    private getDistributors() {
        return { "data": { "distributors": [{ "distributorName": this.dataConstants.CPG_DN, "advancePayFlag": 1, "cpgCode": this.dataConstants.CPG_ID, "invoiceSettings": "{\"e\":2,\"d\":1,\"q\":1,\"c\":1}", "distributorCode": "SBD001", "cpgTag": this.dataConstants.CPG_DN, "payexDistributorCode": "MH0DIST37", "advancePaySetting": "{}" }] }, "error": "", "status": true };
    }

    private getAutoPullResponse() {
        return { "data": true, "status": true };
    }

    private getBuyerOptions(data) {
        return {
            "data": data,
            "status": true
        };
    }

    private getScheduledInvoicesResponse() {
        return {
            "data": {
                invoices: this.offlineData.invoiceResponse.data.invoices.filter(inv => !inv.PS),
                pullDate: '2019-12-22',
                dates: '8,15,22,29'
            }, "status": true
        };
    }

    private getpaySettingsResponse() {
        return { "msg": "", "data": { "divisionClubFlag": 0, "CNFlag": 0, "clubbingFlag": 0, "docCodeClubFlag": 0, "CDFlag": 0, banks: [{ "UMRN_NO": "PAYEX1234567890", "PAYER_BANK": "KOTAK", "AMOUNT_LIMIT": 1500000, "ACCOUNT_NUMBER": "PAYEX1234567890" }, { "UMRN_NO": "PAYEX1234567890_1", "PAYER_BANK": "ICICI", "AMOUNT_LIMIT": 1500000, "ACCOUNT_NUMBER": "PAYEX1234567890_1" }, { "UMRN_NO": "PAYEX1234567890_2", "PAYER_BANK": "HDFC", "AMOUNT_LIMIT": 1500000, "ACCOUNT_NUMBER": "PAYEX1234567890_2" }, { "UMRN_NO": "PAYEX1234567890_3", "PAYER_BANK": "SBI", "AMOUNT_LIMIT": 1500000, "ACCOUNT_NUMBER": "PAYEX1234567890_3" }, { "UMRN_NO": "PAYEX1234567890_4", "PAYER_BANK": "AXIS", "AMOUNT_LIMIT": 1500000, "ACCOUNT_NUMBER": "PAYEX1234567890_4" }], cnSplitAllowed: false }, "status": true };
    }

    private getCreditNotesForInvoice(request) {
        if (request.status === 'pending' || request.payex_txn_ids) {
            if (this.offlineData.pendingCRN && this.offlineData.pendingCRN.length) {
                //remove used CRN from list
                return { "msg": "", "data": this.processCRNResponseForReturn(this.offlineData.pendingCRN), "status": true };
            } else {
                const seedId = 10009000;
                const getCRN = (baseDateForItemDate, index) => {
                    const amt = this.getRandomNo(100000, 20000);
                    const date = this.getRandomDate(baseDateForItemDate, - this.getRandomNo(10)).format('YYYY-MM-DD');
                    const number = `Bz${Date.now() + this.getRandomNo(100000)}`;
                    const type = this.getRandomNo(5) < 4 ? 0 : 4;
                    return { CC: this.dataConstants.CPG_ID, CND: date, CN_BALANCE: amt, CN_ID: seedId + index, CN_STATUS: 0, CN_TYPE: null, CPG_CN_ID: number, DC: "MH0DIST37", DIVISION: null, DN: this.dataConstants.CPG_DN, UI: 1, VT: 0, imgUrl: this.imgUrl };
                };
                const today = moment().startOf('day');
                const baseDate = moment().startOf('day').subtract(this.getRandomNo(45), 'day');
                const noOfItems = this.getRandomNo(100, 20);
                let items = [];
                for (let i = 0; i < noOfItems; i++) {
                    items.push(getCRN(today, i));
                }
                this.offlineData.pendingCRN = items;
                return { "msg": "", "data": this.processCRNResponseForReturn(items), "status": true };
            }
        } else if (request.status === 'used') {
            return { "msg": "", "data": this.offlineData.usedCRN, "status": true };
        }
    }

    private processCRNResponseForReturn(items) {
        return items.filter(item => {
            return !this.offlineData.usedCRNMap[item.CN_ID];
        });
    }

    private getNEFTCREDBalanceResponse() {
        return { "msg": "", "data": { "CC": "", "msg": "", "RC": "", "BAL": 0.0, "resStatus": false, "BALDATE": "", "DC": "" }, "status": true };
    }

    private getCDFactorResponse() {
        return { "msg": "", "data": { "CDT": 1, "CDD": "", "CDF": 0, "CDV": 0, "TI": 2075488, "CDE": 0, "AVL": 0, "PH": "", "NCD": 1575570600000 }, "status": true }
    }

    private getCDFactorResponseMultipay() {
        return { "msg": "", "data": [{ "CDT": 1, "CDD": "", "CDF": 0, "CDV": 0, "TI": 2075488, "CDE": 0, "AVL": 0, "PH": "", "NCD": 1575570600000 }, { "CDT": 1, "CDD": "", "CDF": 0.0, "CDV": 0.0, "TI": 2106451, "CDE": 0, "AVL": 0, "PH": "", "NCD": 1575570600000 }], "status": true };
    }

    private getRandomNo(maxNo, minNo = 0) {
        return Math.max(Math.round(Math.random() * maxNo), minNo);
    }

    private getSixDigitRandomNo() {
        const minNo = 100000; // Minimum 6-digit number
        const maxNo = 999999; // Maximum 6-digit number

        const randomNumber = Math.floor(Math.random() * (maxNo - minNo + 1)) + minNo;
        return randomNumber
    }

    private getRandomDate(baseDate, daysToAdd) {
        const today = moment();
        return today.add(daysToAdd, 'day');
    }

    private getCreditNote() {
        const seller = ['sellerAVariables', 'sellerBVariables'][this.getRandomNo(1,0)]
        const buyerCode = this[seller].buyerCode
        const buyerName = this[seller].userName
        const sellerCode = this[seller].sellerCode
        const docType = "CN"; // For Credit Note, docType is always CN
        // Generate a random credit note amount (adjust range as needed)
        const docAmt = this.getRandomNo(500, 50);
        const currentDate = this.dateUtils.getToday();
        
        // For credit notes, we use a smaller range for docDate generation.
        const noForDocDateGeneration = -1 * this.commonService.getRandomNo(30);        
        const docDate = this.dateUtils.formatDate(
          this.dateUtils.addDaysToDate(currentDate, noForDocDateGeneration), 'YYYY-MM-DD'
        );
        // For this example, we assume the due date is the same as the document date.
        const dueDate = docDate;
        
        // Generate a random docNo (e.g., a 4-digit number)
        const docNo = `${this.getRandomNo(9999, 1000)}`;
        
        // Generate a unique docId in a similar format to invoices:
        const docId = `${sellerCode}~${docNo}~${docType}~${docDate.substring(0, 5)}`;
      
        // Build the credit note object.
        return {
          "buyerCode": buyerCode,
          "docId": docId,
          "docNo": docNo,
          "docDate": docDate,
          "dueDate": dueDate,
          "docDetail": {
            "docAmt": docAmt
          },
          "dueAmt": docAmt,
          "docType": docType,
          "currCode": this.currencyCode,
          "templateNm": "inv-view-tmpl1",
          "custPONum": `${this.getRandomNo(99, 10)}`, // Random PO number (adjust as needed)
          "buyerName": buyerName,
          "docAmt": [{
            amt: docAmt, currCode: this.currencyCode
          }],
          "docTypeDesc": docType,
          "requestToPay": false,
          "taxAmt": 0,
          "status": "PARTIALLY_USED",
          "promiseDate": "",
          "docViewPath": {
            "fetchDocUriReq": {
              "bucketName": "emailsdview-qa",
              "s3Key": `${sellerCode}/creditNote${docNo}.pdf`
            }
          },
          "attachments": false,
          "tags": [],
          "disablePay": false,
          "multipayTag": `${sellerCode}CN${buyerCode}`,
          "sellerCode": sellerCode,
          "ts": Math.floor(Date.now() / 1000),
          "groupId": null,
          "msg": {},
          "displayOnly": false
        };
      }

    private getCreditNotesForPaymnet() {
        var creditNoteResponse = Object.values(JSON.parse(this.storageService.getLocalStorage(Config.webActions.CREDIT_NOTES_LIST)).data.creditNotes)

        if(!creditNoteResponse){
            const creditNoteResponseForList = this.getCreditNotesForList();
            this.storageService.addLocalStorage(Config.webActions.CREDIT_NOTES_LIST,JSON.stringify(creditNoteResponseForList))
            creditNoteResponse =  Object.values(JSON.parse(this.storageService.getLocalStorage(Config.webActions.CREDIT_NOTES_LIST)).data.creditNotes)

        }
        return {
                "data": {
                    "creditNotes": creditNoteResponse
                },
                "success": true,
                "msg": "",
                "msgCode": "DEFAULT_BLANK"
        }
        
    }
    
    private generateGetCreditNoteResponse() {
            const today = moment().startOf('day');
            const baseCNDate = moment().startOf('day').subtract(this.getRandomNo(45), 'day');
            // You may also choose to use a random number for the count; here we're creating 10 credit notes.
            let creditNotes = {};
            let creditNoteOrder = [];
            for (let i = 0; i < 10; i++) {
                const creditNote = this.getCreditNote();
                creditNoteOrder.push(creditNote.docId);
                creditNotes[creditNote.docId] = creditNote;
            }
            const creditNoteResponse = {
                data: {
                    creditNoteOrder: creditNoteOrder,
                    creditNotes: creditNotes,
                    sellerConfig: this.getSellerConfig()
                },
                msg: "",
                msgCode: "DEFAULT_BLANK",
                success: true
            };
            return creditNoteResponse;
        
        
    }

    private getCreditNotesForList() {
        var creditNoteResponse = JSON.parse(this.storageService.getLocalStorage(Config.webActions.CREDIT_NOTES_LIST))

        if(!creditNoteResponse){
            creditNoteResponse = this.generateGetCreditNoteResponse();
            this.storageService.addLocalStorage(Config.webActions.CREDIT_NOTES_LIST,JSON.stringify(creditNoteResponse))

        }
        return creditNoteResponse
    }
      

    private getInvoice(baseDate, baseDateForInvDate, shouldBeOverdue = false, seller = ['sellerAVariables', 'sellerBVariables'][this.getRandomNo(1,0)], currCode = this.currencyCode) {
        const buyerCode = this[seller].buyerCode
        const buyerName = this[seller].userName
        const sellerCode = this[seller].sellerCode
        const docType = ['INV', 'INV', 'DN'][this.getRandomNo(2,0)];
        const docAmt = this.getRandomNo(5000, 200);
        const currentDate = this.dateUtils.getToday();
        const divCode = ['DIV1', 'DIV2', 'DIV3'][this.getRandomNo(2,0)];
        const noForDocDateGeneration = -1 * this.commonService.getRandomNo(180);        
        const docDateObj = this.dateUtils.addDaysToDate(currentDate, noForDocDateGeneration);
        const docDate = this.dateUtils.formatDate(docDateObj, 'YYYY-MM-DD');
        
        // Calculate due date based on doc date to ensure it's always >= doc date
        let dueDateObj;
        const currentDateObj = moment(currentDate).toDate();
        const docDateObjAsDate = moment(docDateObj).toDate();
        
        if (shouldBeOverdue) {
            // For overdue invoices: due date should be in the past (before today) but >= doc date
            // Calculate days between doc date and today, then set due date somewhere in between
            const daysFromDocToToday = Math.floor((currentDateObj.getTime() - docDateObjAsDate.getTime()) / (1000 * 60 * 60 * 24));
            // Make due date 1-30 days in the past from today, but ensure it's not before doc date
            const daysOverdue = this.commonService.getRandomNo(Math.min(30, daysFromDocToToday), 1);
            const daysBeforeToday = daysFromDocToToday - daysOverdue;
            dueDateObj = this.dateUtils.addDaysToDate(docDateObj, Math.max(0, daysBeforeToday));
        } else {
            // For non-overdue invoices: due date should be in the future (after today)
            const daysFromDocToToday = Math.floor((currentDateObj.getTime() - docDateObjAsDate.getTime()) / (1000 * 60 * 60 * 24));
            // Make due date 1-180 days in the future from today
            const daysInFuture = this.commonService.getRandomNo(180, 1);
            dueDateObj = this.dateUtils.addDaysToDate(docDateObj, daysFromDocToToday + daysInFuture);
        }
        const dueDate = this.dateUtils.formatDate(dueDateObj, 'YYYY-MM-DD');
        
        return {

            "buyerCode": buyerCode,
            "docNo": `${docType}2202240${this.getRandomNo(9999,1111)}`,
            "docType": docType,
            "docDate": docDate,
            "dueDate": dueDate,           
            "docAmt": docAmt,
            "dueAmt": docAmt,
            "taxAmt": 0,
            "currCode": currCode,
            "docRef": "",
            "divCode": divCode,
            "text": "",
            "buyerName": buyerName,
            "docId": `${sellerCode}~${docType}22022${this.getSixDigitRandomNo()}~${docType}~${docDate.substring(0, 5)}`,
            "docTypeDesc": docType,
            "requestToPay": false,
            "status": "UNPAID",
            "promiseDate": "",
            "attachments": false,
            "tags": [],
            "disablePay": true,
            "multipayTag": `${sellerCode}00BYRDMOSA`,
            "sellerCode": sellerCode,
            "ts": 1708675901,
            "docViewPath": {
                "fetchDocUriReq": {
                  "bucketName": "emailsdview-qa",
                  "s3Key": "sellerA/invoiceA.pdf"
                }
              },
            "groupId": null,
            "msg": {},
            "displayOnly": false
        }
    }

    private async getInvoiceResponse() {
        var invoicesResponse = JSON.parse(this.storageService.getLocalStorage(Config.webActions.GETINVOICES))

        if(!invoicesResponse){
            invoicesResponse = this.generateGetInvoiceResponse();
            this.storageService.addLocalStorage(Config.webActions.GETINVOICES,JSON.stringify(invoicesResponse))

        }
        return invoicesResponse
    }

    private isInvoiceOverdue(dueDate: string): boolean {
        const today = moment(this.dateUtils.getToday()).toDate();
        today.setHours(0, 0, 0, 0);
        const dueDateObj = new Date(dueDate);
        dueDateObj.setHours(0, 0, 0, 0);
        return dueDateObj < today;
    }

    private generateGetInvoiceResponse(){

        const today = moment().startOf('day');
        const baseInvDate = moment().startOf('day').subtract(this.getRandomNo(45), 'day');
        let invoices = {};
        let invoiceOrder = [];

        // Generate a few USD and a few EUR invoices for each seller, so every
        // seller shows multi-currency invoices. The first invoice of each
        // seller/currency group is overdue to keep some overdue items in the list.
        const sellers = ['sellerAVariables', 'sellerBVariables'];
        // Primary + secondary currency, both configurable via environment.js
        // (DEFAULT_CURR / SECONDARY_CURR).
        const currencies = [Config.defaultCurr, Config.secondaryCurr];
        const invoicesPerGroup = 3;

        for (const seller of sellers) {
            for (const currCode of currencies) {
                for (let i = 0; i < invoicesPerGroup; i++) {
                    const shouldBeOverdue = i === 0;
                    const invoice = this.getInvoice(today, baseInvDate, shouldBeOverdue, seller, currCode);
                    invoiceOrder.push(invoice.docId);
                    invoices[invoice.docId] = invoice;
                }
            }
        }
        const invoiceResponse = {
            data: {
                invoiceOrder : invoiceOrder,
                invoices: invoices,
                sellerConfig : this.getSellerConfig()
                },
            msg: "",
            msgCode: "DEFAULT_BLANK",
            success: true
        };
        return invoiceResponse;
    
    }

    private getTransaction() {
        
        const seller = ['sellerAVariables', 'sellerBVariables'][this.getRandomNo(1,0)]
        const buyerCode = this[seller].buyerCode
        const buyerName = this[seller].userName
        const sellerCode = this[seller].sellerCode
        const docType = ['INV', 'INV', 'DN'][this.getRandomNo(2,0)];
        const status = ['APPROVAL_PENDING', 'APPROVAL_PENDING', 'SUCCESS'][this.getRandomNo(2,0)];
        const docAmt = this.getRandomNo(500000, 20000);
        const currentDate = this.dateUtils.getToday();
        const overrideDueDate = this.getRandomNo(3);
        const noForDocDateGeneration = -1 * this.commonService.getRandomNo(180);
        const docDateObj = this.dateUtils.addDaysToDate(currentDate, noForDocDateGeneration);
        const docDate = this.dateUtils.getFormattedDateForDisplay(docDateObj);
        // Calculate due date based on doc date to ensure it's always >= doc date
        const daysAfterDocDate = overrideDueDate ? 0 : this.commonService.getRandomNo(180, 0);
        const dueDate = this.dateUtils.getFormattedDateForDisplay(this.dateUtils.addDaysToDate(docDateObj, daysAfterDocDate));
        const deduction = this.getRandomNo(5000, 200)
        const TDS10Perc = (docAmt-deduction)*0.1
        const CDAmt = docAmt*0.025
        // Calculate Total Deductions
        const totalDeductions = deduction + TDS10Perc;

        // Calculate Amount After Deductions
        const amountAfterDeductions = docAmt - totalDeductions;

        // Calculate Approved Amount (apprvAmt)
        const apprvAmt = amountAfterDeductions - CDAmt;

        // Bank Amount is the same as Approved Amount
        const bankAmt = apprvAmt;

        // Calculate Payment Amount (payAmt)
        const payAmt = docAmt - deduction;
        const invoices = [
            { 
                "type": "INV",
                "docNo": "IN240224021132",
                "docAmt": docAmt,
                "docDate": "2023-09-23",
                "dueDate": "2024-01-26",
                "buyerCode": "00BYRDMOSA",
                "CDAmt": CDAmt,
                "docApprvAmt": apprvAmt,
                "dueAmt": 0,
                "scd": 0,
                "payAmt" : payAmt,
                "creditNotes": [],
                "CNAmt": 0,
                "bankAmt": bankAmt,
                "reconStatus": "APPROVAL_PENDING",
                "sellerImg": "https://qa.payex.live/eipp/logo/sellerdemo.png",
                "docViewPath": {
                    "fetchDocUriReq": {
                        "bucketName": "emailsdview-qa",
                        "s3Key": "SellerA/00BYRDMOSA-IN240224021132.pdf"
                    }
                },
                "deductions": 
                [
                    {
                        "docId": "IN240224021132",
                        "deductions": [
                            {
                                "reason": "Price Difference",
                                "WHT": false,
                                "amt": deduction,
                                "currCode" : this.currencyCode,
                            },
                            {
                                "reason": "TDS 10%",
                                "WHT": true,
                                "amt": TDS10Perc,
                                "currCode" : this.currencyCode,
                            }
                        ],
                        "amt": deduction + TDS10Perc,
                        "dueAmt": docAmt
                    }
                ],
                "tds" : TDS10Perc,
                "currCode": this.currencyCode,
                "divCode": ""
            }
        ]
        return {
            "sellerCode": sellerCode,
            "buyerCode": buyerCode,
            "status": status,
            "statusDesc": status,
            "payDate": "2024-02-23 05:30:00",
            "totalCdAmt": CDAmt,
            "postingNo": "",
            "ROAmt": 0,
            "apprvAmt": apprvAmt,
            "CNAmt": 0,
            "remarks": "Remarks",
            "bankAmt": bankAmt,
            "advPay": null,
            "WHT": 0,
            "CDAmt": CDAmt,
            "currCode": this.currencyCode,
            "division": {},
            "apprvDate": "2024-02-24 12:04:07",
            "payMode": "PG",
            "pm": "PG",
            "invoices": invoices,
            "headerStatus": "Approval Pending",
            "refTxnId": null,
            "tranAmt": {
                "amt": docAmt,
                "bankAmt": docAmt,
                "currCode": this.currencyCode
            },
            "tranId": "S1021708678600457",
            "tranDate": "2024-02-23 14:26:40",
            "payModeDetail": {
                "PGName": "AiPay",
                "customerRefNo": "",
                "active": true,
                "changePayDate": false,
                "showBalance": false,
                "checkBalance": null,
                "pinRequired": false,
                "sellerPmTitle": "PG",
                "surchargeCode": "",
                "invPayByCN": true,
                "dnPayByCN": true,
                "partialPay": true,
                "partialPayDN": true,
                "cashDiscount": false,
                "pm": "PG",
                "title": "PG-AiPay"
            },
           
            "invCnt": 1,
            "buyerCheckers": []
        }

       
    }

    private getTransactionResponse() {
        var transactionResponse = JSON.parse(this.storageService.getLocalStorage(Config.webActions.GETTRANSACTIONS))

        if(!transactionResponse){
           
            transactionResponse = this.generateGetTransactionResponse();
            this.storageService.addLocalStorage(Config.webActions.GETTRANSACTIONS,JSON.stringify(transactionResponse))
        }
        return transactionResponse
    }

    private generateGetTransactionResponse() {
        const today = moment().startOf('day');
            const baseInvDate = moment().startOf('day').subtract(this.getRandomNo(45), 'day');
            const noOfInvoices = this.getRandomNo(100, 20);
            let transactions = {};
            let order = [];
            for (let i = 0; i < 10; i++) {
                const txn = this.getTransaction()
                txn['tranId'] =  `S102170867860045${i}`,
                txn['_id'] =  `S102170867860045${i}`,
                txn['invoices'][0]['deductions'][0]['docId'] = `${txn['invoices'][0]['deductions'][0]['docId']}${i}`
                order.push(txn.tranId)
                transactions[txn.tranId] = txn
            }
            const transactionResponse = {
                data: {
                    order : order,
                    transactions: transactions,
                    sellerConfig : this.getSellerConfig(),
                    group: {
                        "desc": "",
                        "bg": "#",
                        "isAwaiting": false
                    }
                    },
                msg: "",
                msgCode: "DEFAULT_BLANK",
                success: true
            };
            return transactionResponse;
    }

    private async getTransactionDetails(payload) {
        console.log(payload);
        
        const transactions : any = JSON.parse(this.storageService.getLocalStorage(Config.webActions.GETTRANSACTIONS)).data.transactions
        console.log(transactions);
        
        let transaction
        for (const property in transactions) {
            console.log(transactions[property]);
            if(transactions[property].tranId == payload.transId){
                transaction = transactions[property]
                break;
            }
        }
        var invoices 
       
        return {
            "data": transaction,
            "success": true,
            "msg": "",
            "msgCode": "DEFAULT_BLANK"
        }
    }

    private getSellerConfig() {
        return {
            "SellerA": {
                "invViewPath": "PDF",
                "cnViewPath": "PDF",
                "dnViewPath": "PDF",
                "setS3KeyOnLedgerUpload": false,
                "debitNoteView": false,
                "invPayByCN": true,
                "dnPayByCN": true,
                "multiPayInvDN": true,
                "viewStmt": false,
                "advPayment": true,
                "sellerNm": "SellerA",
                "sellerImg": "https://qa.payex.live/eipp/logo/seller1002.png",
                "allowReject": false,
                "sellerMsg": "",
                "currCode": this.currencyCode,
                "requestToPay": false,
                "partialPayAllowed": true,
                "partialPayAllowedDN": true,
                "cashDiscount": {
                    "active": true,
                    "cashDiscountDisplay": ""
                }
            },
            "SellerB": {
                "invViewPath": "PDF",
                "cnViewPath": "PDF",
                "dnViewPath": "PDF",
                "setS3KeyOnLedgerUpload": false,
                "debitNoteView": false,
                "invPayByCN": true,
                "dnPayByCN": true,
                "multiPayInvDN": true,
                "viewStmt": false,
                "advPayment": true,
                "sellerNm": "SellerB",
                "sellerImg": "https://qa.payex.live/eipp/logo/seller1002.png",
                "allowReject": false,
                "sellerMsg": "",
                "currCode": this.currencyCode,
                "requestToPay": false,
                "partialPayAllowed": true,
                "partialPayAllowedDN": true,
                "cashDiscount": {
                    "active": true,
                    "cashDiscountDisplay": ""
                }
            }
        }
    }

    private getSellers() {
        return {
            "data": {
                "sellers": [
                    {
                        "sellerName": "SellerA",
                        "sellerCode": "SellerA",
                        "allowSingleUserMultiSession": false,
                        "buyerAppSessionTimeout": 5,
                        "advancePayAllowed": true,
                        "advPayWithDeduction": false,
                        "knockOffWaitWindowCheck": false,
                        "payAdvanceByDivision": false,
                        "payAdvanceByDivisionMandatory": false,
                        "pinRequired": true,
                        "currCode": this.currencyCode,
                        "buyers": [
                            {
                                "buyerCode": "00BYRDMOSA",
                                "buyerNm": "BuyerSellerA",
                                "divisions": []
                            }
                        ]
                    },
                    {
                        "sellerName": "SellerB",
                        "sellerCode": "SellerB",
                        "allowSingleUserMultiSession": false,
                        "buyerAppSessionTimeout": 5,
                        "advancePayAllowed": true,
                        "advPayWithDeduction": false,
                        "knockOffWaitWindowCheck": false,
                        "payAdvanceByDivision": false,
                        "payAdvanceByDivisionMandatory": false,
                        "pinRequired": true,
                        "currCode": this.currencyCode,
                        "buyers": [
                            {
                                "buyerCode": "00BYRDMOSB",
                                "buyerNm": "BuyerSellerB",
                                "divisions": []
                            }
                        ]
                    }
                ]
            },
            "success": true,
            "msg": "",
            "msgCode": "DEFAULT_BLANK"
        }
    }

    private processInvoicesForReturn(invoiceData) {
        const paidInvoices = this.offlineData.paidInvoices || {};
        const deferredInvoices = this.offlineData.deferredInvoices || {};
        invoiceData.data.invoices.forEach(inv => {
            if (paidInvoices[inv.II]) {
                inv.AF = '2';
                inv.PS = 30;
            }
            if (deferredInvoices[inv.II]) {
                inv.AF = '2';
                inv.PS = 10;
                inv.AS = 2;
            }
        });
    }

    private addToPaidInvoice(invRequest) {
        const arr = this.offlineData.invoiceResponse.data.transactions.transactions;
        const transaction: any = { "CC": this.dataConstants.CPG_ID, "AA": invRequest.AA, "CD": invRequest.CD, "AB": invRequest.AA, "PR": invRequest.RR, "PS": 30, "AD": moment().format('YYYY-MM-DD HH:mm:ss'), "ABD": "KOTAK#PAYEX1234567890", "PT": 0, "DN": this.dataConstants.CPG_DN, "TA": invRequest.AA, "UD": moment().format('YYYY-MM-DD HH:mm:ss.nn'), "RC": "PAY1234567890", "UTR": "", "PC": invRequest.NOI, "PPR": null, "PD": moment().format('YYYY-MM-DD'), "PI": this.getRandomNo(3000000, 2000000), "PM": 30, "DC": "MH0DIST37", "PO": 0, imgUrl: this.imgUrl };
        if (arr.length) {
            transaction.PI = arr[arr.length - 1].PI + 1;
        }
        arr.push(transaction);
    }

    private addToUsedCN(id) {
        const alreadyExists = this.offlineData.usedCRN.find(item => item.CN_ID === id);
        if (!alreadyExists) {
            const pendingCRN = this.offlineData.pendingCRN.find(item => item.CN_ID.toString() === id.toString());
            if (pendingCRN) {
                this.offlineData.usedCRN.push(pendingCRN);
            }
        }
    }

    private getBankOptions() {
        const data = {
            "data": {
                "payOptions": [
                    {
                        "merchantIdentifier": "M2023010309",
                        "NACHbankNm": "XYZ",
                        "mandateLimit": 110000,
                        "autopull": "false",
                        "NACHBankCode": "XYZ",
                        "umrn": "SBIN2023114502",
                        "changePayDate": true,
                        "showBalance": null,
                        "checkBalance": null,
                        "pinRequired": true,
                        "sellerPmTitle": "ACH",
                        "surchargeCode": "",
                        "invPayByCN": true,
                        "dnPayByCN": true,
                        "partialPay": true,
                        "partialPayDN": false,
                        "pm": "ACH",
                        "title": "ACH-XYZ-4502"
                    },
                    {
                        "NEFTbankNm": "XYZ BANK",
                        "SWIFT": "CHAS0INBX01",
                        "VAccNo": "SBD20367566210151",
                        "changePayDate": false,
                        "showBalance": null,
                        "checkBalance": null,
                        "pinRequired": true,
                        "sellerPmTitle": "NEFT",
                        "surchargeCode": "",
                        "invPayByCN": true,
                        "dnPayByCN": true,
                        "partialPay": true,
                        "partialPayDN": false,
                        "pm": "NEFT",
                        "title": "Wire-Transfer-XYZ BANK-0151"
                    },
                    {
                        "PGName": "AiPay",
                        "customerRefNo": "",
                        "active": true,
                        "changePayDate": false,
                        "showBalance": false,
                        "checkBalance": null,
                        "pinRequired": false,
                        "sellerPmTitle": "PG",
                        "surchargeCode": "",
                        "pm": "PG",
                        "title": "PG"
                    },
                    {
                        "cardType": "visa",
                        "expMonth": "8",
                        "expYear": "2027",
                        "cardLastFourDigit": "0009",
                        "card": "-E803-0009-T8QNSQEN4R1M0P",
                        "name": "Recurring Card",
                        "merchantId": "PAYEX_VAP_CC",
                        "cardFirstSixDigit": "411111",
                        "active": true,
                        "expired": false,
                        "changePayDate": null,
                        "showBalance": null,
                        "checkBalance": null,
                        "pinRequired": true,
                        "sellerPmTitle": null,
                        "surchargeCode": "InterPayment",
                        "pm": "XiCard",
                        "title": null
                    }
                ]
            },
            "success": true,
            "msg": "",
            "msgCode": "DEFAULT_BLANK"
        }
        return data
    }

    private getPaySettings() {
        const data = {
            "data": {
                "partialPay": true,
                "partialPayDN": true,
                "cashDiscount": true,
                "payByCN": true,
                "dnPayByCN": true,
                "cnSplit": "LE",
                "cnSplitOnPartPay": "LE",
                "payMsg": "",
                "promptMsg": "",
                "rejectAllow": true,
                "disputeAllow": false,
                "deductionAllow": true,
                "deductionAllowDN": true,
                "includeCDinDeductions": false,
                "deductionsMandatory": true
            },
            "success": true,
            "msg": "",
            "msgCode": "DEFAULT_BLANK"
        }
        return data
    }

    private getPayReasons() {
        const data = {
            "data": {
                "rejectReasons": [
                    {
                        "reason": "Already Paid by Cheque"
                    },
                    {
                        "reason": " Already Paid by Cash"
                    },
                    {
                        "reason": " Dispute"
                    }
                ],
                "partialPayReasons": [
                    {
                        "reason": "Price Difference",
                        "subReasons": [],
                        "WHT": false
                    },
                    {
                        "reason": "Short Material Receipt",
                        "subReasons": [],
                        "WHT": false
                    },
                    {
                        "reason": "Excess Billing against PO",
                        "subReasons": [],
                        "WHT": false
                    },
                    {
                        "reason": "Material Received in damaged condition Wrong billings",
                        "subReasons": [],
                        "WHT": false
                    },
                    {
                        "reason": "GST Discount Related Errorsd",
                        "subReasons": [],
                        "WHT": false
                    },
                    {
                        "reason": "Ajusted against open Credit Note",
                        "subReasons": [],
                        "WHT": false
                    },
                    {
                        "reason": "Related Errors",
                        "subReasons": [],
                        "WHT": false
                    },
                    {
                        "reason": "Any other reason",
                        "subReasons": [],
                        "WHT": false
                    }
                ],
                "deductions": [
                    {
                        "name": "TDS 1%",
                        "reason": "TDS 1%",
                        "percentage": 1,
                        "amount": -1.0,
                        "baseValueField": "taxAmt",
                        "deductionsMandatory": false,
                        "overwriteDeductions": true,
                        "approvalRequriedByDefault": true,
                        "approvalRequriedOnOverwrite": true,
                        "mandatory": false,
                        "WHT": true
                    },
                    {
                        "name": "TDS 2%",
                        "reason": "TDS 2%",
                        "percentage": 2,
                        "amount": -1,
                        "baseValueField": "dueAmt",
                        "deductionsMandatory": false,
                        "overwriteDeductions": true,
                        "approvalRequriedByDefault": true,
                        "approvalRequriedOnOverwrite": true,
                        "mandatory": false,
                        "WHT": true
                    },
                    {
                        "name": "TDS 0.1%",
                        "reason": "TDS 0.1%",
                        "percentage": 0.1,
                        "amount": -1,
                        "baseValueField": "dueAmt",
                        "deductionsMandatory": false,
                        "overwriteDeductions": true,
                        "approvalRequriedByDefault": true,
                        "approvalRequriedOnOverwrite": true,
                        "mandatory": false,
                        "WHT": true
                    },
                    {
                        "name": "TDS 10%",
                        "reason": "TDS 10%",
                        "percentage": 10,
                        "amount": -1,
                        "baseValueField": "dueAmt",
                        "deductionsMandatory": false,
                        "overwriteDeductions": true,
                        "approvalRequriedByDefault": true,
                        "approvalRequriedOnOverwrite": true,
                        "mandatory": false,
                        "WHT": true
                    },
                    {
                        "name": "TDS 5%",
                        "reason": "TDS 5%",
                        "percentage": 5,
                        "amount": -1,
                        "baseValueField": "dueAmt",
                        "deductionsMandatory": false,
                        "overwriteDeductions": true,
                        "approvalRequriedByDefault": true,
                        "approvalRequriedOnOverwrite": true,
                        "mandatory": false,
                        "WHT": true
                    },
                    {
                        "name": "OTHERS",
                        "reason": "Others",
                        "percentage": -1,
                        "amount": -1,
                        "baseValueField": "dueAmt",
                        "deductionsMandatory": false,
                        "overwriteDeductions": true,
                        "approvalRequriedByDefault": true,
                        "approvalRequriedOnOverwrite": true,
                        "mandatory": false,
                        "WHT": true
                    }
                ]
            },
            "success": true,
            "msg": "",
            "msgCode": "DEFAULT_BLANK"
        }
        return data
    }


    

    private payInvoice(request) {
        console.log("now paying invoices");
        console.log("hehe");
        console.log(request);
      
        // Retrieve transactions and invoices from local storage.
        var transactionReq: any = JSON.parse(this.storageService.getLocalStorage(Config.webActions.GETTRANSACTIONS));
        var invoiceReq: any = JSON.parse(this.storageService.getLocalStorage(Config.webActions.GETINVOICES));
        var transactions: any = transactionReq.data.transactions;
        var orderTransaction : any[] = transactionReq.data.order
        var invoices: any = invoiceReq.data.invoices;
        var orderInvoices = invoiceReq.data.order;
        console.log(transactions);
        console.log(invoices);
      
        const transactionsLength = Object.keys(transactions).length;
        console.log(transactionsLength);
        var date = new Date();
        const nowFormatted = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
        console.log(nowFormatted);
      
        const txnInvoices = [];
        let totalCD =0
        const invoiceCount = request.docIds.length
      
        // Check if deductions are provided.
        let totalWHT = 0
        if (request.docIds && request.docIds.length > 0) {
            request.docIds.forEach((docId: string) => {
              if (invoices.hasOwnProperty(docId)) {
                // Clone the invoice
                let invoice = { ...invoices[docId] };
          
                // Attach matching deductions (if any)
                if (request.deductions && Array.isArray(request.deductions)) {
                  // Filter all deductions for this invoice's docId
                  const matchingDeductions = request.deductions.filter((deductionObj: any) => deductionObj.docId === docId);
                  if (matchingDeductions.length > 0) {
                    invoice.deductions = invoice.deductions && Array.isArray(invoice.deductions)
                      ? invoice.deductions.concat(matchingDeductions)
                      : matchingDeductions;
                  }
                }
          
                // Attach cash discount details (if any)
                if (request.cashDiscount && Array.isArray(request.cashDiscount)) {
                  // Find the cash discount entry matching this docId
                  const matchingCD = request.cashDiscount.find((cd: any) => cd.docId === docId);
                  if (matchingCD && typeof matchingCD.discountAmt === 'number') {
                    invoice.CDAmt = matchingCD.discountAmt; // Place the cash discount amount inside the invoice
                    totalCD += matchingCD.discountAmt;        // Accumulate the total cash discount amount
                  }
                }
          
                // Add the modified invoice to the transaction invoices array.
                txnInvoices.push(invoice);
                
                // Remove the invoice from the main invoices object.
                delete invoices[docId];
              }
            });
          }
      
        // If there are any processed invoices, create a new transaction.
        if (txnInvoices.length > 0) {
          console.log("Number of invoices processed:", txnInvoices.length);
      
          // Generate a new transaction _id based on existing transactions count.
          const newTxnId = `S102170867860046${transactionsLength + 1}`;
      
          // Create a new transaction object that includes details from the payment object.

        let totalCNAmt = 0;
        if (request.cnsSelected && Array.isArray(request.cnsSelected) && request.cnsSelected.length > 0) {
            request.cnsSelected.forEach((creditNote) => {
            if (creditNote.cnAmt && Array.isArray(creditNote.cnAmt)) {
                creditNote.cnAmt.forEach((item) => {
                totalCNAmt += item.amt;
                });
            }
            });
        }


        var txn = this.getTransaction()

        
        const newTransaction = {
          tranId: newTxnId,
          _id : newTxnId,
          invoices: txnInvoices,
          payDate: nowFormatted,
          sellerCode: request.sellerCode,
          buyerCode: request.buyerCode,
          payAmt: request.payAmt,
          bankAmt: request.bankAmt,
          apprvAmt: request.bankAmt,
          paymentModeDetail: request.paymentMode,
          pm: request.pm,
          payMode: request.pm,
          tranAmt: {
              "amt": request.bankAmt,
              "bankAmt": request.bankAmt,
              "currCode": this.currencyCode
          },
          CNAmt : totalCNAmt,
          CDAmt : totalCD,
          totalCdAmt : totalCD,
          WHT : totalWHT,
          remarks: request.remarks,
          // Optionally include other fields as needed.
        };

        Object.assign(txn,newTransaction)
        

        orderTransaction.unshift(txn.tranId)
        transactions[txn.tranId] = txn
      
        }
      
      
        // Update the local storage with the new transactions and invoices objects.
        transactionReq.data.transactions = transactions;
        transactionReq.data.order = orderTransaction
        invoiceReq.data.invoices = invoices;
        console.log(transactions);
        console.log(invoices);
        
        this.storageService.addLocalStorage(Config.webActions.GETINVOICES, JSON.stringify(invoiceReq));
        this.storageService.addLocalStorage(Config.webActions.GETTRANSACTIONS, JSON.stringify(transactionReq));
      
        // Return the response.
        const data = {
          "data": {
            "ppi": "VALVO1712750425731",
            "paymentStatus": true,
            "redirectUrl": "",
            "pinValidationFailed": false
          },
          "success": true,
          "msg": "Thank you! To make a NEFT/RTGS/IMPS payment login to your banking portal or visit your local branch and make a payment to <br/><br/>Account Number : VAL7000260525177 <br/>SWIFT Code : HDFC2001123",
          "msgCode": "DEFAULT_BLANK"
        };
        return data;
      }
      












    private deferInvoice(invRequest) {
        const deferredInvoices = this.offlineData.deferredInvoices || {};
        invRequest.II.toString().split(',').forEach(invId => {
            deferredInvoices[invId] = 1;
        });
        return { "msg": 'Your Deferment request has been sent to ABC Insurance Company. The final acceptance or rejection will be communicated via an SMS to you.\n', "error": "", "status": true }
    }

    private advancePay(advRequest) {
        console.log("offline service adv pay");
        
        var transactionReq: any = JSON.parse(this.storageService.getLocalStorage(Config.webActions.GETTRANSACTIONS));
        var invoiceReq: any = JSON.parse(this.storageService.getLocalStorage(Config.webActions.GETINVOICES));
        var transactions: any = transactionReq.data.transactions;
        var orderTransaction : any[] = transactionReq.data.order
        var invoices: any = invoiceReq.data.invoices;
        var orderInvoices = invoiceReq.data.order;

        var date = new Date();
        const nowFormatted = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
        

        var txn = this.getTransaction()

        delete txn[invoices]


        const advReq = {
            "sellerCode": "Polymak",
            "buyerCode": "PM147",
            "payAmt": 55,
            "paymentMode": {
                "PGName": "AiPay",
                "active": true,
                "changePayDate": true,
                "showBalance": false,
                "checkBalance": null,
                "pinRequired": true,
                "sellerPmTitle": "PG-AiPay",
                "surchargeCode": "",
                "pm": "PG",
                "title": "PG-AiPay",
                "currencyCode": ""
            },
            "payDate": 1739145600000,
            "tpin": "7777",
            "remarks": "",
            "sdflag": false,
            "UI": "2",
            "session": {
                "sessionId": "81574e3b-7b9e-4653-9b0a-0263ebcb3b08_41960797369734887",
                "username": "9444414681",
                "sessionTimeout": 30,
                "expiryDate": 1739163402495
            }
        }
        const transactionsLength = Object.keys(transactions).length;
        const newTxnId = `S102170867860046${transactionsLength + 1}`;


        const advPayTxn = {
            advPay : {
                amt : advRequest.payAmt,
                refNo : "1234567890"
            },
            apprvAmt: advRequest.payAmt,
            apprvDate: nowFormatted,
            bankAmt: advRequest.payAmt,
            pm : advRequest.paymentMode.pm,
            payModeDetail : advRequest.paymentMode,
            tranAmt: {amt: advRequest.payAmt, bankAmt: advRequest.payAmt, currCode: this.currencyCode},
            tranDate: "2025-02-10 09:59:38"
        }

        Object.assign(txn,advPayTxn)


        orderTransaction.unshift(txn.tranId)
        transactions[txn.tranId] = txn

        transactionReq.data.transactions = transactions;
        transactionReq.data.order = orderTransaction
        invoiceReq.data.invoices = invoices;
        console.log(transactions);
        console.log(invoices);
        
        this.storageService.addLocalStorage(Config.webActions.GETINVOICES, JSON.stringify(invoiceReq));
        this.storageService.addLocalStorage(Config.webActions.GETTRANSACTIONS, JSON.stringify(transactionReq));
        
        let PI = this.getRandomNo(3000000, 2000000);


       
        const today = moment();
        const currentTime = today.format('YYYY-MM-DD HH:mm:ss');
        const currentDate = today.startOf('day').format('YYYY-MM-DD');
        const currentTimestamp = Date.now();
        const invoice = { "RR": advRequest.RR, "DD": currentDate, "PS": 30, "ABD": "KOTAK#PAYEX1234567890", "I": 1, "DN": this.dataConstants.CPG_DN, "UD": currentTime, "BR": "", "UTR": "", "SF": "S00", "MC": false, "IA": advRequest.AA, "ID": currentDate, "CC": this.dataConstants.CPG_ID, "AA": advRequest.AA, "CD": 0.0, "AB": advRequest.AA, "ACD": 0.0, "AD": currentTime, "AF": "0", "IN": `AP_${currentTimestamp}`, "IS": "{}", "IT": 2, "CR": "CPG1234567890", "PCD": 0.0, "RC": "PAY1234567890", "PA": advRequest.AA, "PD": currentTimestamp, "TCD": 0, "PI": PI, "SCD": 0.0, "PM": 30, "VT": 0, "DC": "MH0DIST28", "BA": advRequest.AA, "PO": 0, imgUrl: this.imgUrl }
        const msg = { "msg": `Authorization initiated for payment of Rs.${advRequest.AA}.00 on ${moment().format('DD-MM-YYYY')} .\nThank you for using Freepay.`, 
        "data": {
            paymentStatus : true,
            pinValidationFailed : false,
            ppi: "1383540935389398", "invoice": invoice 
        }, 
        "error": "", "status": true }
        console.log("returning");
        
        return msg;
    }

    private advancePaySettings(req) {
        return {
            "data": {
                "bankOptions": [
                    {
                        "merchantIdentifier": "M1003202303",
                        "NACHbankNm": "XYZ",
                        "mandateLimit": 500000,
                        "autopull": "false",
                        "NACHBankCode": "XYZ",
                        "umrn": "SBIN0001003202303",
                        "changePayDate": true,
                        "showBalance": null,
                        "checkBalance": null,
                        "pinRequired": true,
                        "sellerPmTitle": "ACH",
                        "surchargeCode": "",
                        "pm": "ACH",
                        "title": "ACH-XYZ-2303"
                    },
                    {
                        "NEFTbankNm": "XYZ",
                        "SWIFT": "CHAS0INBX01",
                        "VAccNo": "SBD1003202303",
                        "changePayDate": false,
                        "showBalance": null,
                        "checkBalance": null,
                        "pinRequired": true,
                        "sellerPmTitle": "NEFT",
                        "surchargeCode": "",
                        "isNEFTByBuyer": false,
                        "buyerVAccNo": "",
                        "vaccLength": 4,
                        "pm": "NEFT",
                        "title": "NEFT-XYZ-2303"
                    },
                    {
                        "cardType": "visa",
                        "expMonth": "7",
                        "expYear": "2025",
                        "cardLastFourDigit": "0009",
                        "card": "-E803-0009-T8QNSQEN4R1M0P",
                        "name": "Recurring Card",
                        "merchantId": "PAYEX_VAP_CC",
                        "cardFirstSixDigit": "411111",
                        "active": true,
                        "expired": false,
                        "changePayDate": null,
                        "showBalance": null,
                        "checkBalance": null,
                        "pinRequired": true,
                        "sellerPmTitle": null,
                        "surchargeCode": "InterPayment",
                        "pm": "XiCard",
                        "title": null
                    },
                    {
                        "accountNumber": "-E803-9999-EJSRD6YHZS8R5V",
                        "accountLastFourDigit": "9999",
                        "paymentOption": "corporate",
                        "routingNumber": "011075150",
                        "bankName": "Lloyd bank",
                        "nameOnAccount": "Recurring check",
                        // "nameOnAccount": "Elizabeth McRecurr1907202309",
                        "merchantId": "PAYEX_VAP_EC",
                        "active": "true",
                        "pm": "XiCheck",
                        "title": null
                    }
                ]
            },
            "success": true,
            "msg": "",
            "msgCode": "DEFAULT_BLANK"
        }
    }

    private getCurrencies(req){
        return {
            "status": "success",
            "message": "list loaded successfully",
            "data": [
                {
                    "merchantId": "PAYEX_VAP_CC",
                    "currencyCode": "USD",
                    "currencyName": "US Dollar"
                },{
                    "merchantId": "PAYEX_VAP_CC",
                    "currencyCode": "INR",
                    "currencyName": "Indian Rupee"
                },{
                    "merchantId": "PAYEX_VAP_EC",
                    "currencyCode": "USD",
                    "currencyName": "US Dollar"
                },{
                    "merchantId": "PAYEX_VAP_EC",
                    "currencyCode": "INR",
                    "currencyName": "Indian Rupee"
                }
            ]
        }
    }

    private ribbonData(request) {
        const dataObj = {};
        request.docDetails.forEach(docDetail => {
            dataObj[docDetail.sellerCode] = [];
            docDetail.docIds.forEach(docId => {
                const messages = [];
                ['PENAL', 'CD', 'DUE'].forEach(msgType => {
                    messages.push({
                        type: msgType,
                        msg: `This is ${msgType} for inv ${docId}.`
                    });
                })
                dataObj[docDetail.sellerCode].push({
                    docId: docId,
                    msgs: messages
                });
            })
        })
        return {
            msg: '',
            status: true,
            data: {}
        }
    }

    private async viewStatement(): Promise<Blob> {
        const filePath = '../assets/offline/ViewStatement.xlsx'; // Adjust path if needed
    
        try {
            const blob = await this.http.get(filePath, { responseType: 'blob' }).toPromise();
            console.log('Blob:', blob);
            return blob!;
        } catch (error) {
            console.error('Error fetching the file:', error);
            throw error;
        }
    }
    
    
   private async setPaymentSchedule(request) {
    const id = CryptoJS.SHA256(Date.now().toString()).toString();
    // console.log("Request to set payment schedule:", request);
    
    if (request.isUpdation) {
        return this.updatePaymentSchedule(request);
    }

    const reqObj = {
        id: id,
        title: request.paymentSchedule.title,
        sellerName: request.paymentSchedule.seller.sellerName,
        payMethod: request.paymentSchedule.payMethod,
        paused: request.paymentSchedule.paused,
        sellerCode: request.paymentSchedule.seller.sellerCode,
    };

    let storedData = await this.storageService.get(StringConstants.MANAGE_AUTOPAY_LIST);
    let paymentScheduleWrapper = storedData || { paymentSchedule: [] }; 
    
    if (!paymentScheduleWrapper.paymentSchedule) {
        paymentScheduleWrapper.paymentSchedule = [];
    }
    paymentScheduleWrapper.paymentSchedule.push(reqObj);
    
    await this.storageService.add(StringConstants.MANAGE_AUTOPAY_LIST, paymentScheduleWrapper);
}

private async getPaymentSchedule() {
    const storedData = await this.storageService.get(StringConstants.MANAGE_AUTOPAY_LIST);
    const paymentSchedule = storedData || { paymentSchedule: [] };
    return paymentSchedule;
}

private async deletePaymentSchedule(request) {
    // console.log("Request to delete payment schedule:", request);
    const paymentScheduleWrapper = await this.storageService.get(StringConstants.MANAGE_AUTOPAY_LIST) || { paymentSchedule: [] };
    const paymentScheduleList = paymentScheduleWrapper.paymentSchedule;

    const index = paymentScheduleList.findIndex(schedule => schedule.id === request.id);
    if (index !== -1) {
        // Save updated list
        // console.log("Before deletion:", paymentScheduleList);
        paymentScheduleList.splice(index, 1);
        await this.storageService.add(StringConstants.MANAGE_AUTOPAY_LIST, { paymentSchedule: paymentScheduleList });
        // console.log("After deletion:", paymentScheduleList);
        return { success: true, message: "Payment schedule deleted successfully.", data: paymentScheduleList };
    } else {
        // console.log("No schedule found with id:", request.id);
        return { success: false, message: "Payment schedule not found." };
    }
}

private async updatePaymentSchedule(request) {
    // console.log("Request to update payment schedule:", request);
    const paymentScheduleWrapper = await this.storageService.get(StringConstants.MANAGE_AUTOPAY_LIST) || { paymentSchedule: [] };
    const paymentScheduleList = paymentScheduleWrapper.paymentSchedule;
    
    const index = paymentScheduleList.findIndex(schedule => schedule.id === request.paymentSchedule.id);
    // console.log("paymentScheduleList before update:", paymentScheduleList, "\nindex to update:", request.paymentSchedule.id, "\nindex found:", index);

    if (index !== -1) {
        // console.log("Before update:", paymentScheduleList);
        paymentScheduleList[index] = {
            ...paymentScheduleList[index],
            ...request.paymentSchedule
        };
        // Save updated list
        await this.storageService.add(StringConstants.MANAGE_AUTOPAY_LIST, { paymentSchedule: paymentScheduleList });
        // console.log("After update:", paymentScheduleList);
        return { success: true, message: "Payment schedule updated successfully.", data: paymentScheduleList };
    } else {
        // console.log("No schedule found with id:", request.id);
        return { success: false, message: "Payment schedule not found." };
    }
}

}
